export default {
  title: "Talento"
  , form: {
    nombre: { label: "Nombre completo" }
    , email: { label: "E-mail de contacto", hint: "E-mail" }
    , linkedin: { label: "LinkedIn", hint: "LinkedIn" }
    , pais: { label: "País" }
    , provincia: { label: "Provincia / Estado" }
    , localidad: { label: "Localidad / Delegación" }
    , perfiles: {
      label: "Tu perfil/es"
      , hint: "Puedes elegir > 1"
      , note: "(Agrega solo aquellos donde tengas más experiencia)"
    }
    , telefonos: {
      label: "Teléfonos <span class='small-text'>(Click en el botón</span> <span> + </span><span class='small-text'>para añadir más de 1 teléfono)</span>"
      , th: "Teléfono"
      , th2: "Teléfono"
    }
    , usuarios: {
      label: "Usuarios <span class='small-text'>(Puedes añadir más de 1 usuario)</span>"
      , th: "Usuario"
      , th2: "Usuario"
    }
    , tipoTelefono: { label: "Tipo de teléfono" }
    , tipoUsuario: { label: "Tipo de usuario" }
    , idiomas: {
      label: "Idiomas <span class='small-text'>(Puedes añadir más de 1 idioma)</span>"
      , th: "Idiomas"
    }
    , nivelIdioma: { label: "Nivel de idioma" }
    , nivelHabilidad: { label: "Nivel de habilidad" }
    , observaciones: { label: "Cuéntanos más sobre tí" }
    , rangoSalarial: { label: "Rango Salarial" }
    , adjuntos: {
      label: "Adjunta tú CV <span class='small-text'>(obligatorio)</span>"
      , th: "Adjuntos"
    }
    , video: {
      label: "Si lo deseas, cuéntanos más sobre tí en un video de presentación personal <span class='small-text'>(máximo 5 minutos)</span>"
      , th: "Video"
    }
    , titulouni: {
      label: "Título universitario"
      , th: "Título universitario"
    }
    , token: { label: "Ingrese el token enviado", hint: "Token" }
    , copy: { label: "Click para copiar" }
    , captcha: { label: "Por favor resuelva el captcha" }
    , resend: { label: "Re-enviar email" }
    , avatar: { label: "Compártenos tu foto <span class='small-text'>(opcional)</span>" }
    , loading: {
      label: "Enviando su solicitud al equipo de Nexion Solutions, gracias."
      , desc: "Nos pondremos en contacto contigo a la brevedad."
    }
    , steps: { step1: { title: "Únete a nuestra Base de Talentos" } }
  }
  , errors: {
    BD7000: { text: "Ocurrió un error en el catálogo de Talento" }
    , WS7000: { text: "Ocurrió un error en el catálogo de Talento" }
    , JS7000: { text: "Ocurrió un error en el catálogo de Talento" }
    , CR7000: { text: "Ocurrió un error en el catálogo de Talento" }
    , OL7000: { text: "El registro fue modificado por alguien mas, recargue el registro antes de intentar actualizarlo nuevamente" }
    , token: { text: "El token es incorrecto" }
    , UK_Talento: { text: "Ya existe un registro con el mismo nombre en la misma localización geográfica" }
    , UK_Talento_Email: { text: "Ya existe un registro con el mismo email" }
    , telefonoNoDuplicado: { text: "Ya existe un talento registrado con ese teléfono" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/talento.js